var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 736v160h160l472.107-472.107-160-160L128 736zm755.413-435.413c16.64-16.64 16.64-43.734 0-60.374l-99.626-99.626c-16.64-16.64-43.734-16.64-60.374 0l-78.08 78.08 160 160 78.08-78.08z"
  })));
};
export default SvgEdit;